import { createActionGroup, emptyProps } from '@ngrx/store';

export const AccountTeamStripeRedirectActions = createActionGroup({
  source: 'Account Team Stripe Redirect',
  events: {
    'Cancel Button Hidden': emptyProps(),
    'Redirect Cancel Clicked': emptyProps(),
  },
});
